export default class ListSchedulePointsController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    schedulePoints
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.schedulePoints = schedulePoints;
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step4');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
